import { STATUS_TINDAKAN } from "../../../utils/constants/StatusTindakan.constants";
import API from "../../../utils/helpers/API.helpers";

const StafSekreService = {
  async getStafSekreList() {
    return await API.get({ endpoint: "/staf_sekre/" });
  },
  async createStafSekre(stafSekreDetails) {
    return await API.post({ endpoint: "/staf_sekre/", data: stafSekreDetails });
  },
  async updateStafSekre(stafSekreDetails) {
    return await API.put({
      endpoint: `/staf_sekre/${stafSekreDetails.id}/`,
      data: { username: stafSekreDetails.username },
    });
  },
  async deleteStafSekre(stafSekreId) {
    return await API.delete({ endpoint: `/staf_sekre/${stafSekreId}/` });
  },
  async getDashboardStafSekre(statusTindakan, term, tipe = null) {
    if (statusTindakan == STATUS_TINDAKAN.butuh_tindakan) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/butuh-tindakan?term=${term}`,
      });
    } else if (statusTindakan == STATUS_TINDAKAN.menunggu_pihak_lain) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/menunggu-tindakan?tipe=${tipe}&&term=${term}`,
      });
    } else if (statusTindakan == STATUS_TINDAKAN.selesai) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/selesai?term=${term}`,
      });
    } else if (statusTindakan == STATUS_TINDAKAN.semua) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/semua?term=${term}`,
      });
    } else if (statusTindakan == STATUS_TINDAKAN.statistik) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/stats?term=${term}`,
      });
    }
  },
  async getInfoDashboardStafSekre(term) {
    if (term) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/info?term=${term}`,
      });
    }
  },
  async getStatsDashboardStafSekre(term) {
    if (term) {
      return await API.get({
        endpoint: `/staf_sekre/dashboard/stats?term=${term}`,
      });
    }
  },
  async getInfoKelolaSidangStafSekre(term) {
    if (term) {
      return await API.get({
        endpoint: `/staf_sekre/kelola-sidang/info?term=${term}`,
      });
    }
  },
};

export { StafSekreService };
